import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withConditionalFeatures } from '@americanexpress/conditional-features';
import style from './CenturionWordmark.scss';
import {
  hasCenturionImageInHeader,
} from '../../constants/featureRulesConstants';

const CenturionWordmark = ({
  showImageInsteadOfText,
}) => {
  const { formatMessage } = useIntl();
  return (
    showImageInsteadOfText ? (
      <div
        className={clsx('flex flex-justify-around margin-t-md-up pad-1-t anim-fade-in anim-delay-10 hidden-sm-down', style.centurionWordmark)}
      >
        <img
          id="centurionWordmarkPNG"
          src="https://icm.aexp-static.com/Internet/travel/homepage/images/headerImages/Cent_logo.png"
          alt={formatMessage({ id: 'centurionWordmark' })}
        />
      </div>
    ) : (
      <div
        className={clsx('margin-t-md-up pad-1-t dls-white text-align-center anim-fade-in anim-delay-10 hidden-sm-down', style.centurionWordmark)}
      >
        {/* eslint-disable-next-line react/no-danger -- Enable */}
        <p dangerouslySetInnerHTML={{ __html: formatMessage({ id: 'centurionWordmark' }) }} />
      </div>
    ));
};

CenturionWordmark.propTypes = {
  showImageInsteadOfText: PropTypes.bool.isRequired,
};

export const mapFeaturesToProps = {
  showImageInsteadOfText: hasCenturionImageInHeader,
};

const hocChain = compose(
  withConditionalFeatures({ mapFeaturesToProps })
);

export { CenturionWordmark as TestableCenturionWordmark };

export default hocChain(CenturionWordmark);
